// module imports
import eventLogger from 'modules/Logger'
// constant imports
import { EVENT_DISPATCHER, N2P_EVENT_NAME } from 'constants/GlobalEvents'

// for docs see docs/global-events.md
export const eventDispatch = (event, data = {}) => {
  eventLogger.info('global_event', { event, data })
  window.dispatchEvent(
    new CustomEvent(N2P_EVENT_NAME, {
      detail: {
        dispatcher: EVENT_DISPATCHER,
        event,
        data,
      },
    }),
  )
}

export const eventSubscribe = (eventName, callback) => {
  eventLogger.info('listening_for_event', { eventName })
  window.addEventListener(eventName, callback)
}

export const eventUnsubscribe = (eventName, callback) => {
  eventLogger.info('listening_for_event', { eventName })
  window.removeEventListener(eventName, callback)
}
